<template>
  <b-card class="mb-0 h-100">
    <template #header>
      <i class="fas fa-shield-alt"></i>{{ $lang.Menu.Items.Access.PCI.Departaments }}
    </template>
    <div class="d-flex flex-column h-100">
      <div class="d-flex flex-grow-0">
        <div class="row w-100">
          <div class="d-flex flex-wrap col-md-8">
            <div class="d-flex col-md-12">
              <v-select
                v-model="selectedUser"
                :options="users"
                :reduce="user => user.value"
                label="text"
                @input="onSelectUser"
                class="w-100"
                :placeholder="`-- ${$lang.Access.SelectUser} --`"
              >
              </v-select>
              <div v-if="showItems">
                <b-button variant="third" class="no-round ml-3" @click="saveUserAccess">{{ $lang.Common.Buttons.Save }}</b-button>
              </div>
            </div>
            <div class="d-flex col-md-12 h-100">
              <item-tree-view :list="items"
                              :showCheckbox="true"
                              :showSearch="false"
                              :startOpen="true"
                              v-if="showItems && selectedUser"
                              :serializer="p => p.name">
              </item-tree-view>
            </div>
          </div>
          <div class="col-md-6">
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import Departaments from './departaments'
export default Departaments
</script>

<style scoped>
  .card {
    max-height: calc(100vh - 185px);
  }
  .card .col-6 {
    height: calc(100vh - 250px);
  }
</style>



// WEBPACK FOOTER //
// src/views/private/access/pci/departaments/departaments.vue